import { render, staticRenderFns } from "./MeetingCard.vue?vue&type=template&id=2b4a46ca&scoped=true&"
import script from "./MeetingCard.vue?vue&type=script&lang=js&"
export * from "./MeetingCard.vue?vue&type=script&lang=js&"
import style0 from "./MeetingCard.vue?vue&type=style&index=0&id=2b4a46ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a46ca",
  null
  
)

export default component.exports